import { Component, OnInit,ViewChild } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';
import swal from 'sweetalert2';  

@Component({
  selector: 'app-rolecard',
  templateUrl: './rolecard.component.html',
  styleUrls: ['./rolecard.component.scss']
})
export class RolecardComponent implements OnInit {
  @ViewChild('cexp',null) cexp;
  constructor(public authService: AuthService,
    public router: Router) { }
    are1=true;
  ngOnInit() {
    try {
      this.role_id=Number(localStorage.getItem("id_role"));
      console.log("id_role: "+this.role_id)
    } catch (error) {
      
    }
    this.get_org();
    this.ls_rolecard();
    this.ls_competencia();
  }
  _competencia;
  ls_competencia(){    
    let postData = { 
      id_cliente:localStorage.getItem("id_cliente"),
    } 
    console.log(postData);
    this.authService.service("/api/get_competencia_cliente",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          console.log("competencia");
          console.log(res);
          this._competencia=res;
          
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta! gdareportto', '', 'error');
        });   
    
  }

  org;
  org_;
  loading;
  role_id=0;
  _rolecard;
  v_role=false;
  migrate=0;
  bndDepa=false;
  _mAre1=0;
  _mAre2=0;
  ls_rolecard(){
    this.loading=true;
    let postData = {
      role_id:this.role_id
    }
    this._rolecard=[];
    console.log(postData);
    this.authService.service("/api/get_rolecard_id",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        this._rolecard=data[0];
        console.log("rolecard");
        console.log(data);
        this.loading=false;

        if (this._rolecard.director==1){
          this.bndDepa=true;
        }else{
          this.bndDepa=false;
        }
        //this.ls_area();
        this.migrate=1;
        this.v_role=true;
        this._mAre1=0;
        this._mAre2=0;
        this.limpia_role();
        this.bndJD=true;
        this.are1=true;
        this.are2=true;       
        this.exp.id=this._rolecard.id;
        this.exp.id_persona=this._rolecard.id_persona;
        this.exp.posicion=this._rolecard.titulo;
        this.exp.descripcion=this._rolecard.descripcion;
        this.exp.lider=this._rolecard.lider;
        
        this._mAre1=this._rolecard.idarea1;
        this._mAre2=this._rolecard.idarea2;
        this.exp.txdirRep1=this._rolecard.txdirRep1;
        this.exp.txdirRep2=this._rolecard.txdirRep2;
        this.exp.departamento=this._rolecard.departamento;
        this.btnmigrate=false;
        this.msg_rolecard="";
        this.hidCvePersona=this._rolecard.id;
        this.cda=[];
        this.kdr=[];
        this.kpi=[];
        this.dke=[];
        this.get_reportto(this._rolecard.id)
        this.ls_cda(this._rolecard.id);
        this.ls_kdr(this._rolecard.id);
        this.ls_kpi(this._rolecard.id);
        this.ls_dke(this._rolecard.id);
        this.ls_we(this._rolecard.id);
        this.ls_edu(this._rolecard.id);
        this.ls_jcom(this._rolecard.id);
        this.ls_phy(this._rolecard.id);

      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('API incorrecta!', '', 'error');
          this.loading=false;
      });
  }
  gda_reportto(){
    this.loading=true;
    let postData = {
      id_persona:this.hidCvePersona,
      id_report:this._mAre2 } 
      //console.log(postData);
      this.authService.service("/api/gda_reportto",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);              
            
            this.get_reportto(this.hidCvePersona);                  
            this.loading=false;   
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              this.loading=false;
              swal.fire('¡API incorrecta! gdareportto', '', 'error');
          });   
  
  }
  reportto:any;
  get_reportto(cve){
    this.reportto=[];
    //console.log("reporto");
    let postData = {
      id_persona:cve } 
      //console.log(postData);
      this.loading=true;
      this.authService.service("/api/get_reportto",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);                        
            this.reportto=data;
            this.loading=false;           
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              this.loading=false;
              swal.fire('¡API incorrecta! reportto', '', 'error');
          });   
  
  
  }
  sel1;
  n_are1;
  gda_are1(){

  }
  ws=[];
  can_are1(){

  }
  gda_exp(){
    //console.log("aqui ");
    let postData = {
      id_persona:this.hidCvePersona,
      descripcion:this.exp.descripcion,
      titulo:this.exp.posicion,
      departamento:this.exp.departamento,
      area1:this._mAre1,
      area2:this._mAre2
    } 
    this.loading=true;
      console.log(postData);
      this.authService.service("/api/gda_experience_role",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);  
              this.ls_area();
              this.get_reportto(this.hidCvePersona);
              swal.fire('Success ok', '', 'success');
              this.loading=false; 
              
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta! gexp', '', 'error');
              this.loading=false;           
          });   
  }
  area:any;
  ls_area(){
    let postData = {
      id_raci:0,
      id_cliente:localStorage.getItem("id_cliente")
    }
    //console.log(postData);
    this.authService.service("/api/get_role",postData)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        if (res.length!=0)
        {
          //console.log(res);
          this.area=data;         
                       
        }
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('API incorrecta!', '', 'error');
      });  

}
ins_phy(){
  if(this.descipcion_phy==undefined || this.descipcion_phy=="")return ;
  let postData = {
    id:this.hidCvePersona,
    id_role:this.exp.id,
    des:this.descipcion_phy
  } 
    console.log(postData);
    this.authService.service("/api/ins_pdwe_role",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0)
          {
            this.ls_phy(this.hidCvePersona);
            this.descipcion_phy="";
          }           
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });   
}
ins_jcom(){
  if(this.selComp==undefined || this.selComp==0)return ;
  let postData = {
    id:this.hidCvePersona,
    id_role:this.exp.id,
    id_competencia:this.selComp
  } 
    console.log("jcom");
    console.log(postData);
    this.authService.service("/api/ins_jcom",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0)
          {
            this.ls_jcom(this.hidCvePersona);
            this.descipcion_jcom="";
          }           
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });   
}
txtgrado="";
txtanio_=0;
ins_edu(){
  if(this.descipcion_edu==undefined || this.descipcion_edu=="")return ;
  let postData = {
    id:this.hidCvePersona,
    id_role:this.exp.id,
    descripcion:this.descipcion_edu,
    anio:0,
    grado:""

  } 
    //console.log(postData);
    this.authService.service("/api/ins_edu",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0)
          {
            this.ls_edu(this.hidCvePersona);
            this.descipcion_cda="";
          }           
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });   
}
txtanio=0;
empresa_="";
ins_we(){
  if(this.descipcion_we==undefined || this.descipcion_we=="")return ;
  let postData = {
    id:this.hidCvePersona,
    id_role:this.exp.id,
    descripcion:this.descipcion_we,
    anio:Number(this.txtanio),
    id_persona:0,    
    empresa:""
  } 
    console.log(postData);
    this.authService.service("/api/ins_we",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);                      
          this.ls_we(this.hidCvePersona);
          this.descipcion_we="";
          this.txtanio=0;
          this.empresa_="";
                     
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });   
}  

ins_cda(){
    if(this.descipcion_cda==undefined || this.descipcion_cda=="")return ;
    let postData = {
      id:this.hidCvePersona,
      id_role:this.exp.id,
      descripcion:this.descipcion_cda
    } 
      //console.log(postData);
      this.authService.service("/api/ins_cda",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);              
            if (res.length!=0)
            {
              this.ls_cda(this.hidCvePersona);
              this.descipcion_cda="";
            }           
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta!', '', 'error');
          });   
  }
  descipcion_cda="";
  ins_kdr(){
    if(this.descipcion_kdr==undefined || this.descipcion_kdr=="")return ;
    let postData = {
      id:this.hidCvePersona,
      id_role:this.exp.id,
      descripcion:this.descipcion_kdr
    } 
      //console.log(postData);
      this.authService.service("/api/ins_kdr",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);              
            if (res.length!=0)
            {
              this.ls_kdr(this.hidCvePersona);
              this.descipcion_kdr="";
            }           
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta!', '', 'error');
          }); 
  }
  descipcion_kdr="";
  ins_kpi(){
    if(this.descipcion_kpi==undefined || this.descipcion_kpi=="")return ;
    let postData = {
      id:this.hidCvePersona,
      id_role:this.exp.id,
      descripcion:this.descipcion_kpi
    } 
      //console.log(postData);
      this.authService.service("/api/ins_kpi",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);              
            if (res.length!=0)
            {
              this.ls_kpi(this.hidCvePersona);
              this.descipcion_kpi="";
            }           
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta!', '', 'error');
          }); 
  }
  descipcion_kpi="";
  descipcion_dke="";
  ins_dke(){
    if(this.descipcion_dke==undefined || this.descipcion_dke=="")return ;
    let postData = {
      id:this.hidCvePersona,
      id_role:this.exp.id,
      descripcion:this.descipcion_dke
    } 
      //console.log(postData);
      this.authService.service("/api/ins_dke",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);              
            if (res.length!=0)
            {
              this.ls_dke(this.hidCvePersona);
              this.descipcion_dke="";
            }           
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta!', '', 'error');
          }); 
  }
  del_we(itm){
    let postData = {
      id:itm.id
    } 
      //console.log(postData);
      this.authService.service("/api/del_we",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);              
            if (res.length!=0)
            {
              this.ls_we(this.hidCvePersona);
            }           
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta!', '', 'error');
          });   
  }
  del_edu(itm){
    let postData = {
      id:itm.id
    } 
      //console.log(postData);
      this.authService.service("/api/del_educacion",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);                         
            this.ls_edu(this.hidCvePersona);                     
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta!', '', 'error');
          });   
  }
  selComp=0;
  del_jcom(itm){
    let postData = {
      id:itm.id
    } 
      console.log(postData);
      this.authService.service("/api/del_jcom",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);              
            
              this.ls_jcom(this.hidCvePersona);
                       
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta!', '', 'error');
          });   
  }
  del_phy(itm){
    let postData = {
      id:itm.id
    } 
      //console.log(postData);
      this.authService.service("/api/del_pdwe",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);              
            if (res.length!=0)
            {
              this.ls_phy(this.hidCvePersona);
            }           
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta!', '', 'error');
          });   
  }
  del_cda(itm){
    let postData = {
      id:this.hidCvePersona
    } 
      //console.log(postData);
      this.authService.service("/api/del_cda",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);              
            if (res.length!=0)
            {
              this.ls_cda(this.hidCvePersona);
            }           
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta!', '', 'error');
          });   
  }
  del_kdr(itm){
    let postData = {
      id:this.hidCvePersona
  
    } 
      //console.log(postData);
      this.authService.service("/api/del_kdr",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);              
            if (res.length!=0)
            {
              this.ls_kdr(this.hidCvePersona);
            }           
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta!', '', 'error');
          }); 
  }
  del_kpi(itm){
    let postData = {
      id:this.hidCvePersona
    } 
      //console.log(postData);
      this.authService.service("/api/del_kpi",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);              
            if (res.length!=0)
            {
              this.ls_kpi(this.hidCvePersona);
            }           
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta!', '', 'error');
          }); 
  }
  del_dke(itm){
    let postData = {
      id:this.hidCvePersona
    } 
      //console.log(postData);
      this.authService.service("/api/del_dke",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);              
            if (res.length!=0)
            {
              this.ls_dke(this.hidCvePersona);
            }           
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta!', '', 'error');
          }); 
  }
  hidCvePersona;
  are2;
  ls_phy(id_){
    let postData = {id_role:id_} 
    //console.log(postData);
    this.authService.service("/api/get_pdwe_role",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);    
            this.phy=data;          
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });  
  }
  ls_jcom(id_){
    let postData = {id_role:id_} 
    //console.log(postData);
    this.authService.service("/api/get_jcom",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          console.log("lsjcom");
          console.log(res);
            this.jcom=data;
           
          
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });  
  }
  ls_edu(id_){
    let postData = {id_role:id_} 
    console.log(postData);
    this.authService.service("/api/get_educacion_role",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
         console.log(res)
            this.edu=data;
          
          
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });  
  }
  ls_we(id_){
    let postData = {id_role:this.role_id} 
    //console.log(postData);
    this.authService.service("/api/get_we_role",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0)
          {
            this.we=data;
          } 
          
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });  
  }
  ls_cda(id_){
    let postData = {id:id_} 
    //console.log(postData);
    this.authService.service("/api/get_cda",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0)
          {
            this.cda=data;
          } 
          
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });  
  }
  ls_kdr(id_){
    let postData = {id:id_  } 
    //console.log(postData);
    this.authService.service("/api/get_kdr",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0)
          {
            this.kdr=data;
          } 
          
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });
  }
  ls_kpi(id_){
    let postData = {id:id_ } 
    //console.log(postData);
    this.authService.service("/api/get_kpi",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0)
          {
            this.kpi=data;
          } 
          
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });
  }
  
  ls_dke(id_){
    let postData = { id:id_ } 
    //console.log(postData);
    this.authService.service("/api/get_dke",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0)
          {
            this.dke=data;
          } 
          
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });
  } 
  cda:any;
  kdr:any;
  kpi:any;
  dke:any; 
  we:any;
  edu:any;
  jcom:any;
  phy:any;
  descipcion_we="";
  descipcion_edu="";
  descipcion_jcom="";
  descipcion_phy="";
  btnmigrate=false;
  msg_rolecard="";
  get_experience(id_){
    this.exp.posicion="";
    this.exp.descripcion="";
    this.exp.departamento="";
    this._mAre1=0;
    let postData = {
      id:id_
    } 
    this.loading=true;
      //console.log(postData);
      this.authService.service("/api/get_experience",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);              
            if (res.length!=0)
            {
              
            } else{
              this.msg_rolecard="Doesn't exist a Role Card linked";
              this.btnmigrate=true;
              //console.log("no hay role");
            }        
            this.loading=false; 
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta! exp', '', 'error');
          });   
          this.loading=false;
  }
  persona={
    id:0, 
    id_role:0, 
    foto:"",
     nombre:"",
     paterno:"",
     materno:"",
     profesion:"",
     fec_ingreso:"",     
     chart:0
   };
  get_org(){
    let postData = {
      id_cliente:localStorage.getItem("id_cliente")
    } 
      console.log(postData);
      this.authService.service("/api/get_org_role",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);              
              console.log(data);
                this.org=data;
                      
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta! exp', '', 'error');
          });   
    }
  _regresa(){
    this.router.navigate(['/org']);
  }
  bndJD:boolean=false;
bndcda:boolean=false;
bndkdr:boolean=false;
bndkpi:boolean=false;
bnddke:boolean=false;
bndnr:boolean=false;
bnddo:boolean=false;
bndphy:boolean=false;
bndjcom:boolean=false;
bndedu:boolean=false;
bndwe:boolean=false;
p1;p2;p3;
c1;c2;c3;c4;c5;c6;c7;c8;c9;c10;
c11;c12;c13;c14;c15;c16;
limpia_role(){
  this.bndJD=false;
  this.bndcda=false;
  this.bndkdr=false;
  this.bndkpi=false;
  this.bnddke=false;
  this.bndnr=false;
  this.bnddo=false;
  this.bndphy=false;
  this.bndjcom=false;
  this.bndedu=false;
  this.bndwe=false;
  
}
  show__(t){
    switch(t){
      case 'nr':
        if(this.bndnr==true){
          this.limpia_role();
        }else{
          this.limpia_role();
          this.bndnr=true;
        }
        break;
      case 'do':
        if(this.bnddo==true){
          this.limpia_role();
        }else{
          this.limpia_role();
          this.bnddo=true;
        }
          break;
      case 'jd':      
        if(this.bndJD==true){
          this.limpia_role();
        }else{
          this.limpia_role();
          this.bndJD=true;
        }
        break;
      case 'cda':
        if(this.bndcda==true){
          this.limpia_role();
        }else{
          this.limpia_role();
          this.bndcda=true;
        }
        break;
      case 'kdr':
        if(this.bndkdr==true){
          this.limpia_role();
        }else{
          this.limpia_role();
          this.bndkdr=true;
        }   
        break;
      case 'kpi':
        if(this.bndkpi==true){
          this.limpia_role();
        }else{
          this.limpia_role();
          this.bndkpi=true;
        }
        break;
      case 'dke':
        if(this.bnddke==true){
          this.limpia_role();
        }else{
          this.limpia_role();
          this.bnddke=true;
        }
        break;
        case 'we':
          if(this.bndwe==true){
            this.limpia_role();
          }else{
            this.limpia_role();
            this.bndwe=true;
          }
        break;
        case 'edu':
          if(this.bndedu==true){
            this.limpia_role();
          }else{
            this.limpia_role();
            this.bndedu=true;
          }
        break;
        case 'jcom':
          if(this.bndjcom==true){
            this.limpia_role();
          }else{
            this.limpia_role();
            this.bndjcom=true;
          }
        break;
        case 'phy':
          if(this.bndphy==true){
            this.limpia_role();
          }else{
            this.limpia_role();
            this.bndphy=true;
          }
        break;
    }
  
  }

  exp={
    id:0,
    id_persona:0,
    posicion:"",
    txdirRep1:"",
    txdirRep2:"",
    descripcion:"",
    departamento:"",
    lider:0,
    chart:0
  }
}
